import { mountVueWithPinia } from '../vue/mountVue';
import { audienceLibrary, waitForDYObject } from '@utils/global-functions';
import { passJsonAsProp } from '@utils/ProductResources';
import {
  mountDYAudienceRecommendations,
  loadDYRecommendationSliders,
} from '@utils/dyResources';
import ProductGrid from '../vue/ProductCards/ProductGrid.vue';
import ProductSlider from '../vue/ProductCards/ProductSlider.vue';

export class ProductGrids extends HTMLElement {
  constructor(context) {
    super();
    if (context) this.mountProductCards(context);
  }
  async mountProductCards(context) {
    //if the in page navigation module exists on a landing page or PLP, prevent auto scrolling to the top of the page on load
    if (!document.querySelector('.page-navigation')) window.scrollTo(0, 0);

    const app = context.querySelector('.js-product-grid');
    const jsonScript = context.querySelector('.js-product-grid-json');
    if (!app || !jsonScript) return;
    await passJsonAsProp(app, jsonScript.innerHTML);
    mountVueWithPinia('.js-product-grid', ProductGrid, context);
  }
}

//Call the DY choose endpoint once per page load, if there are DY recommendation sections on the page
document.addEventListener('DOMContentLoaded', function () {
  const dySliders = document.querySelectorAll(
    '[data-ht-module="dy-recommendation-slider"]'
  );
  if (dySliders.length > 0) {
    loadDYRecommendationSliders(dySliders);
  }
});
export class ProductSliders extends HTMLElement {
  constructor(context) {
    super();
    if (context) this.mountProductCards(context);
  }
  async mountProductCards(context) {
    const app = context.querySelector('.js-product-slider');
    //if the product slider is powered by DY audiences, wait for the audience DY data to come in, then grab the correct audience specific JSON to mount Vue.
    if (context.classList.contains('audience-strategies')) {
      waitForDYObject()
        .then((obj) => {
          const matchedAudience = audienceLibrary.filter((audience) =>
            obj.audiences.includes(audience.id)
          )?.[0];
          //if DY does not load, just default recommendations to the low intent strategy
          const audienceId = matchedAudience.index || 1;
          return context.querySelector(
            `.js-product-slider-json[data-audience="${audienceId}"]`
          );
        })
        .then((recommendationData) => {
          mountDYAudienceRecommendations(app, context, recommendationData);
        });
    } else if (!app.classList.contains('js-dy-product-slider')) {
      //mount product cards regularly
      const jsonScript = context.querySelector('.js-product-slider-json');
      if (!app || !jsonScript) return;
      await passJsonAsProp(app, jsonScript.innerHTML);
      mountVueWithPinia('.js-product-slider', ProductSlider, context);
    }
  }
}

customElements.define('product-grid', ProductGrids);
customElements.define('product-slider', ProductSliders);
